import { render } from "./AssignementsSubmitted.vue?vue&type=template&id=711eeef2&scoped=true"
import script from "./AssignementsSubmitted.vue?vue&type=script&lang=js"
export * from "./AssignementsSubmitted.vue?vue&type=script&lang=js"

import "./AssignementsSubmitted.vue?vue&type=style&index=0&id=711eeef2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-711eeef2"]])

export default __exports__